import * as React from 'react';
import { Container } from "reactstrap";
import BotonExcelDefault from './mapButtonExcelDefault'
import { Box} from "@mui/material";

const ItemTable = ({items}) => {

  const markers = items

  return (  
    <Container className="pt-5">
      <Box>
        <BotonExcelDefault markers={markers} />
      </Box>
    </Container>
  );
};

export default ItemTable;